import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { processSteps } from "../../PayroleMocks";
import { CalendarIcon } from "../../../../images/icons/icons";
import { convertStraight } from "../../../common-data/Converts";
import PaginationModified from "../../../../data/PaginationModified";

const ProcessingNotifications = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
}) => {
  const {
    employeePayrollNotificationsData,
    employeePayrollNotificationsLoading,
    employeePayrollNotificationsError,
  } = useSelector((state) => state.payrole);

  const iniDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniDatas);

  function getPagination() {
    try {
      const pagination = allDatas?.pagination ? allDatas?.pagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (
      !employeePayrollNotificationsLoading &&
      !employeePayrollNotificationsError &&
      employeePayrollNotificationsData?.status &&
      employeePayrollNotificationsData?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: employeePayrollNotificationsData.data,
        pagination:
          employeePayrollNotificationsData?.pagination?.length > 0
            ? employeePayrollNotificationsData.pagination
            : [],
      }));
    } else {
      setAllDatas(iniDatas);
    }
  }, [
    employeePayrollNotificationsLoading,
    employeePayrollNotificationsError,
    employeePayrollNotificationsData,
  ]);

  return (
    <div className="pp-payroll-employee-layout">
      <div className="pp-payroll-notifications-section">
        <div className="pp-notifications-header">
          <h3 className="pp-notifications-title">
            Notifications
            <span className="pp-notification-count">2</span>
          </h3>
        </div>

        <div className="pp-notifications-list">
          {allDatas.allData?.map((notification, index) => (
            <div
              key={index.id}
              className={`pp-payroll-notification-item ${
                notification?.type || "NA"
              }`}
            >
              <div className="pp-notification-header">
                <div className="pp-notification-user">
                  <CalendarIcon color="#6b7280" />
                  <span className="pp-notification-name">
                    {notification?.name || "NA"}
                  </span>
                  <div
                    className={`pp-payroll-notification-status ${
                      notification?.is_read ? "inactive" : "active"
                    }`}
                  />
                </div>
              </div>
              <p className="pp-notification-message">
                {notification?.body || "NA"}
              </p>
              <div className="pp-notification-footer">
                <span className="pp-notification-timestamp">
                  {notification?.date
                    ? convertStraight(notification.date)
                    : "-"}
                </span>
                <span
                  className={`pp-payroll-notification-action ${
                    notification?.type === "discrepency" ? "required" : "done"
                  }`}
                >
                  {notification?.type?.replace(/_/g, " ") || "NA"}
                </span>
              </div>
            </div>
          ))}

          <div className="customTablePaginationContainer">
            <PaginationModified
              isPage={isPage}
              onChangePage={setIsPage}
              pagination={getPagination()}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
            />
          </div>
        </div>
      </div>

      <div className="pp-payroll-process-flow">
        <h3 className="pp-process-flow-title">Process Flow</h3>

        <div className="pp-process-steps">
          {processSteps.map((step) => (
            <div
              key={step.id}
              className={`pp-payroll-flow-step step-${step.number}`}
            >
              <div className={`pp-payroll-step-number ${step.color}`}>
                {step.number}
              </div>
              <div className="pp-payroll-step-content">
                <h4 className="pp-payroll-step-title">{step.title}</h4>
                <p className="pp-payroll-step-description">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProcessingNotifications;
